import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";
import { MdThumbDown, MdThumbUp } from "react-icons/md";

const StateTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const module = queryParams.get("module");
  const IsAdmin = localStorage.getItem("IsAdmin");

  const [stateData, setStateData] = useState([]);

  const fetchStateData = async () => {
    const result = await fetchData("states", {}, "POST");
    if (result) {
      const states = result.states || [];
      states.sort((a, b) => a.state_title.localeCompare(b.state_title));

      setStateData(states);
    }
  };

  const toggleStateStatus = async (Id) => {
    const result = await fetchData(`toggle-status-state/${Id}`, {}, "POST");

    if (result && result.code === 200) {
      fetchStateData();
      if (result?.status === 1) {
        topTost({
          title: "Status updated successfully: Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully: Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle state status:", result?.message);
    }
  };

  const columns = [
    ...(IsAdmin === "yes" || permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.state_id;
              const is_active = row.original.status;

              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <FiEdit3
                      className="cursor-pointer"
                      onClick={() => navigate(`/master/edit-state/${id}`)}
                      title="Edit"
                    />
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStateStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStateStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    ,
    {
      accessorKey: "state_title",
      header: () => "State",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchStateData();
  }, []);

  return (
    <>
      <Table data={stateData} columns={columns} />
    </>
  );
};

export default StateTable;
